import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import {
  ActivityLogsIcon,
  EnergyblocksSvgIcon,
  VouchersIcon,
} from '../icons/IconProvider';
const Sidebar = () => {
  const location = useLocation();
  const [isSideBar, setSideBar] = useState();
  useEffect(() => {
    const listener = (event) => {
      setSideBar(event.detail);
    };
    window.addEventListener('sideOpen', listener);
    return () => {
      window.removeEventListener('sideOpen', listener);
    };
  }, []);
  return (
    <>
      <div
        className={`p-4 rounded-lg bg-brandGray w-32 h-[70vh] overflow-auto gap-4 min-h-[calc(100vh-132px)] left-4 fixed top-[116px] sideBar
          ${isSideBar ? 'open md:block' : 'md:block hidden'}`}
      >
        <div className="w-11 h-11 rounded-full flex items-center justify-center bg-black bg-opacity-5 md:hidden absolute top-5 right-5">
          <XMarkIcon
            onClick={() => setSideBar(false)}
            className="h-5 w-5 text-red "
            aria-hidden="true"
          />
        </div>
        <a href="/dashboard" className="md:hidden block">
          <div className="rounded-md text-center px-2 py-3 cursor-pointer mb-4 active-state">
            <EnergyblocksSvgIcon />
          </div>
        </a>
        <NavLink to="/dashboard">
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <img
              src="/img/menu-icons/dashboard.svg"
              alt="Dashboard"
              className="md:mx-auto md:mb-2 mr-3"
            />
            <p className="md:text-xs text-sm text-brandBlue truncate">
              Dashboard
            </p>
          </div>
        </NavLink>
        <NavLink to="/assets">
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <img
              src="/img/menu-icons/project-icon.svg"
              alt="Owned Assets"
              className="md:mx-auto md:mb-2 mr-3"
            />
            <p className="md:text-xs text-sm text-brandBlue truncate">Assets</p>
          </div>
        </NavLink>
        <NavLink
          to="/users/list"
          className={location.pathname.includes('users') ? 'active' : ''}
        >
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <img
              src="/img/menu-icons/users-icon.svg"
              alt="Assets"
              className="md:mx-auto md:mb-2 mr-3"
            />
            <p className="md:text-xs text-sm text-brandBlue truncate">Users</p>
          </div>
        </NavLink>
        <NavLink to="/transactions/fiat/list">
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <img
              src="/img/menu-icons/transaction-icon.svg"
              alt="Transactions"
              className="md:mx-auto md:mb-2 mr-3"
            />
            <p className="md:text-xs text-sm text-brandBlue truncate">
              Transactions
            </p>
          </div>
        </NavLink>
        <NavLink
          to="/payout/list"
          className={location.pathname.includes('payout') ? 'active' : ''}
        >
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <img
              src="/img/menu-icons/payout-icon.svg"
              alt="Payout"
              className="md:mx-auto md:mb-2 mr-3"
            />
            <p className="md:text-xs text-sm text-brandBlue truncate">Payout</p>
          </div>
        </NavLink>

        <NavLink to="/vouchers/list">
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <VouchersIcon />
            <p className="md:text-xs text-sm text-brandBlue truncate">
              Vouchers
            </p>
          </div>
        </NavLink>
        <NavLink to="/configuration">
          <div className="rounded-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <img
              src="/img/menu-icons/settings-icon.svg"
              alt="Configuration"
              className="md:mx-auto md:mb-2 mr-3"
            />
            <p className="md:text-xs text-sm text-brandBlue truncate">
              Configuration
            </p>
          </div>
        </NavLink>
        <NavLink to="/activity-logs/list">
          <div className="rounded md:mx-auto md:mb-2 mr-3-md text-center hover:bg-menuHover px-2 py-3 cursor-pointer mb-3 md:block flex items-center group">
            <ActivityLogsIcon />
            <p className="md:text-xs text-sm text-brandBlue truncate">
              Activity Logs
            </p>
          </div>
        </NavLink>
      </div>
      <div
        onClick={() => setSideBar(false)}
        className={`fixed w-full h-full bg-black/50 left-0 top-0 z-10
          ${isSideBar ? 'block' : 'hidden'}`}
      ></div>
    </>
  );
};

export default Sidebar;
